<ion-content [fullscreen]="true">
  <ion-grid>
    <ion-row>
      <ion-col>
        <app-info-varsling-popup
          *ngFor="let i = index; let message; of: infoMessages"
          [popupId]="i"
          [message]="message"
        ></app-info-varsling-popup>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="hasLinkedVehicle && !doSetup">
      <ion-col class="menu-line">
        <ion-button class="dark-primary" (click)="showMenuModal()">
          Administrer
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_946_9896"
              style="mask-type: alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_946_9896)">
              <path
                d="M7 20L2 15L7 10L8.4 11.425L5.825 14H13V16H5.825L8.4 18.575L7 20ZM17 14L15.6 12.575L18.175 10H11V8H18.175L15.6 5.425L17 4L22 9L17 14Z"
                fill="white"
              />
            </g>
          </svg>
        </ion-button>
        <ion-modal
          [isOpen]="showMenu"
          [backdropDismiss]="true"
          cssClass="admin-menu-modal-content"
          (didDismiss)="menuDismissed($event)"
        >
          <ng-template>
            <app-admin-menu-modal
              [locations]="locations"
              [vehicles]="vehicles"
              [selectedVehicleId]="selectedVehicleId"
              (locationsChanged)="locationsChanged($event)"
            ></app-admin-menu-modal>
          </ng-template>
        </ion-modal>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!doSetup">
      <ion-col>
        <ion-title>
          <h1>Smartlading</h1>
        </ion-title>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="hasFetchingErrorEnodeMe">
      <ion-col>
        <div>
          <p>Klarte ikke hente data. Vennligst prøv på nytt.</p>
          <ion-button (click)="getMe()">Prøv på nytt</ion-button>
        </div>
      </ion-col>
    </ion-row>
    <!-- No vehicle linked, start setup -->
    <ion-row
      *ngIf="!isLoading && !(hasLinkedVehicle) && !doSetup"
      class="centering-container"
    >
      <app-onboarding></app-onboarding>
    </ion-row>
    <ion-row *ngIf="doSetup && newVehicle" class="centering-container">
      <app-setup
        [vehicle]="newVehicle"
        (emitSetupDone)="finishSetup()"
      ></app-setup>
    </ion-row>
    <!-- TODO: Should be behind admin button on top -->
    <ion-row *ngIf="!doSetup && hasLinkedVehicle">
      <ion-col class="ion-text-center">
        <!-- <ion-button [class]="enodeMe && hasLinkedVehicle ? '':'dark'"
          >Legg til ny bil</ion-button
        > -->
        <p>
          <ion-icon
            name="refresh"
            (click)="getVehicles()"
            class="refresher"
          ></ion-icon>
        </p>
        <div *ngIf="hasFetchingErrorVehicles">
          <p>Klarte ikke hente data. Vennligst prøv på nytt.</p>
          <ion-button (click)="getVehicles()">Prøv på nytt</ion-button>
        </div>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!doSetup" class="vehicle-container">
      <ion-col class="ion-text-center">
        <div class="m-3" *ngIf="isLoading">
          <ion-spinner name="crescent"></ion-spinner>
        </div>
        <div *ngIf="enodeMe && hasLinkedVehicle && vehicles">
          <div *ngFor="let vehicle of vehicles">
            <div
              *ngIf="vehicle.id === selectedVehicleId"
              class="mb-8 wrapper-margin"
            >
              <app-vehicle
                [vehicle]="vehicle"
                [chargeActionMessages]="chargeActionMessages"
                [locations]="locations"
              ></app-vehicle>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
